<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToChineesStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/chinees/Asset 7.png" alt="">
    <img draggable="false" id="obj__1" src="./../../assets/images/chinees/Asset 5.png" alt="">
    <img draggable="false" id="obj__2" src="./../../assets/images/chinees/Asset 4.png" alt="">

    <span id="chinees_start_text">Chinees nieuw jaar</span>
    <span v-html="texts[selected_text]" id="chinees_intro_text"></span>

    <img  draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
    <img  draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">

    <img v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true" draggable="false" @click="goToGame()" class="clickable" id="inheems_game_intro_btn" src="./../../assets/images/Asset 30.png" alt="">
  </span>
</template>

<script>
// Puzzle code
// https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_flip_card

import swal from 'sweetalert2'

export default {
  name: "ChineesIntro",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: 0,
      texts: [
        "Wist je dat Chinees Nieuwjaar elk jaar op een andere dag valt? Dat komt omdat Chinezen een speciale kalender hebben, en hun nieuwjaar begint meestal in onze maand februari. Chinees Nieuwjaar wordt gevierd wanneer er een nieuwe maan is, dus als de maan verstopt is. <br><br> In Suriname, is iedereen vrij om Chinees Nieuwjaar te vieren als ze willen. Bijna alle Chinese winkels zijn op die dag gesloten! Waarom zouden ze dat doen, denk je?",

        "Elk jaar heeft in de Chinese kalender de naam van een dier. Bijvoorbeeld, 2019 was het jaar van het varken (of zwijn, klinkt grappig, toch?). Er zijn nog 11 andere dieren, zoals de rat, de tijger, en zelfs de draak! En raad eens? Elk van deze dieren komt om de 12 jaar terug. Dat betekent dat als je in een varkensjaar bent geboren (zoals 2007, 2019, 2031), je iets hebt van het karakter van dat schattige varken. Mensen zeggen dat ze aardig zijn en van gezelligheid en lekker eten houden. Wie wil dat nou niet?",
        
        "Nu, laten we het hebben over kleuren! Rood is de Chinese gelukskleur. Dus als je nu tijdens Chinees Nieuwjaar rode lampionnen, draken en pagara's ziet, weet je waarom. Ze gebruiken ook vuurwerk om de boze geesten weg te jagen. Stel je voor, je begint het nieuwe jaar met positieve energie en veel plezier! <br><br> Dus, de volgende keer dat je Chinees Nieuwjaar hoort, onthoud dan deze mooie feitjes: een speciale kalender, dierenjaar, rode kleur, en vuurwerk om boze geesten te verjagen. Het is een feest vol tradities en geluk!",

        "Om de dieren van het Chinese jaar beter te leren kennen, hebben we een leuk spel voor jou bedacht: een Memory game!! Je hebt vast weleens Memory gespeeld, toch? <br><br> Nou, van elk dier hebben we er twee verstopt, en het is aan jullie om ze te vinden. Het wordt een spannende zoektocht.  Wie weet waar die schattige draken, slimme apen en andere fantastische dieren verstopt zijn? Het is tijd om jullie geheugen en speurneus te gebruiken. <br><br> Veel succes en vooral veel plezier!"
      ]
    };
  },

  methods: {
    goToChineesStart() {
      this.$router.push('/chinees/start');
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
    goToGame() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: true,
      });

      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Welke niveau wil je spelen?</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Moeilijk',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Makkelijk",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.$router.push('/chinees/game/easy');
          } else {
            that.$router.push('/chinees/game');
          }
        });
    },
  },

  computed: {},
  watch: {}
};
</script>

<style>
  #chinees_intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 9%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 2vw;
    text-align: center;
  }
</style>


